import { render, staticRenderFns } from "./DbCheck.vue?vue&type=template&id=c8eec342&"
import script from "./DbCheck.vue?vue&type=script&lang=ts&"
export * from "./DbCheck.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports